/**
 * Created by mauget on 3/5/16.
 */

// PageCollection.js

import { Collection }   from 'backbone';
import PageModel        from 'PageModel.js';

//===============================================================
// A Backbone collection of editor page models.
// Each model has a reference to the page name, thumbnail, and
// information about each kind of contained object.
//
// -Lou Mauget, March 5, 2016
//===============================================================
class PageCollection extends Collection {

    initialize() {
        this.model = PageModel;
    }

}

const pageCollection = new PageCollection();
export default pageCollection;
